import { createApiQuery } from "../../generated-factory";
import { apiClientManager } from "@app/stores/api-manager";
import type { UseGetBillingDetailRequest, UseGetBillingDetailData, UseGetBillingListRequest, UseGetBillingListData, UseGetGroupSummaryRequest, UseGetGroupSummaryData, UseGetMemberVoucherDetailRequest, UseGetMemberVoucherDetailData, UseGetMemberVoucherListRequest, UseGetMemberVoucherListData, UseGetPaymentDetailRequest, UseGetPaymentDetailData, UseGetPaymentListRequest, UseGetPaymentListData, UseGetPaymentStatsRequest, UseGetPaymentStatsData, UseGetVoucherListRequest, UseGetVoucherListData } from "@api/@types/charge";

export const useGetBillingDetail = createApiQuery<UseGetBillingDetailData, UseGetBillingDetailRequest>({
  queryKey: (req) => ["getBillingDetail", req?.groupId, req?.billingId],
  queryFn: (req) => apiClientManager.apis.charge.getBillingDetail(req as UseGetBillingDetailRequest),
  extractData: (res) => res.data.data as UseGetBillingDetailData,
  isEnabled: (req) => Boolean(req?.groupId && req?.billingId),
});

export const useGetBillingList = createApiQuery<UseGetBillingListData, UseGetBillingListRequest>({
  queryKey: (req) => ["getBillingList", req?.groupId, req?.status, req?.memberId, req?.startDate, req?.endDate],
  queryFn: (req) => apiClientManager.apis.charge.getBillingList(req as UseGetBillingListRequest),
  extractData: (res) => res.data.data as UseGetBillingListData,
  isEnabled: (req) => Boolean(req?.groupId),
});

export const useGetGroupSummary = createApiQuery<UseGetGroupSummaryData, UseGetGroupSummaryRequest>({
  queryKey: (req) => ["getGroupSummary", req?.groupId, req?.type],
  queryFn: (req) => apiClientManager.apis.charge.getGroupSummary(req as UseGetGroupSummaryRequest),
  extractData: (res) => res.data.data as UseGetGroupSummaryData,
  isEnabled: (req) => Boolean(req?.groupId),
});

export const useGetMemberVoucherDetail = createApiQuery<UseGetMemberVoucherDetailData, UseGetMemberVoucherDetailRequest>({
  queryKey: (req) => ["getMemberVoucherDetail", req?.groupId, req?.memberId, req?.memberVoucherId],
  queryFn: (req) => apiClientManager.apis.charge.getMemberVoucherDetail(req as UseGetMemberVoucherDetailRequest),
  extractData: (res) => res.data.data as UseGetMemberVoucherDetailData,
  isEnabled: (req) => Boolean(req?.groupId && req?.memberId && req?.memberVoucherId),
});

export const useGetMemberVoucherList = createApiQuery<UseGetMemberVoucherListData, UseGetMemberVoucherListRequest>({
  queryKey: (req) => ["getMemberVoucherList", req?.groupId, req?.memberId, req?.status, req?.showAll],
  queryFn: (req) => apiClientManager.apis.charge.getMemberVoucherList(req as UseGetMemberVoucherListRequest),
  extractData: (res) => res.data.data as UseGetMemberVoucherListData,
  isEnabled: (req) => Boolean(req?.groupId && req?.memberId),
});

export const useGetPaymentDetail = createApiQuery<UseGetPaymentDetailData, UseGetPaymentDetailRequest>({
  queryKey: (req) => ["getPaymentDetail", req?.groupId, req?.paymentId],
  queryFn: (req) => apiClientManager.apis.charge.getPaymentDetail(req as UseGetPaymentDetailRequest),
  extractData: (res) => res.data.data as UseGetPaymentDetailData,
  isEnabled: (req) => Boolean(req?.groupId && req?.paymentId),
});

export const useGetPaymentList = createApiQuery<UseGetPaymentListData, UseGetPaymentListRequest>({
  queryKey: (req) => ["getPaymentList", req?.groupId, req?.status, req?.method, req?.startDate, req?.endDate, req?.memberId],
  queryFn: (req) => apiClientManager.apis.charge.getPaymentList(req as UseGetPaymentListRequest),
  extractData: (res) => res.data.data as UseGetPaymentListData,
  isEnabled: (req) => Boolean(req?.groupId),
});

export const useGetPaymentStats = createApiQuery<UseGetPaymentStatsData, UseGetPaymentStatsRequest>({
  queryKey: (req) => ["getPaymentStats", req?.groupId, req?.startDate, req?.endDate],
  queryFn: (req) => apiClientManager.apis.charge.getPaymentStats(req as UseGetPaymentStatsRequest),
  extractData: (res) => res.data.data as UseGetPaymentStatsData,
  isEnabled: (req) => Boolean(req?.groupId),
});

export const useGetVoucherList = createApiQuery<UseGetVoucherListData, UseGetVoucherListRequest>({
  queryKey: (req) => ["getVoucherList", req?.groupId, req?.withInactive, req?.type],
  queryFn: (req) => apiClientManager.apis.charge.getVoucherList(req as UseGetVoucherListRequest),
  extractData: (res) => res.data.data as UseGetVoucherListData,
  isEnabled: (req) => Boolean(req?.groupId),
});

export type { UseGetBillingDetailRequest, UseGetBillingDetailData, UseGetBillingListRequest, UseGetBillingListData, UseGetGroupSummaryRequest, UseGetGroupSummaryData, UseGetMemberVoucherDetailRequest, UseGetMemberVoucherDetailData, UseGetMemberVoucherListRequest, UseGetMemberVoucherListData, UseGetPaymentDetailRequest, UseGetPaymentDetailData, UseGetPaymentListRequest, UseGetPaymentListData, UseGetPaymentStatsRequest, UseGetPaymentStatsData, UseGetVoucherListRequest, UseGetVoucherListData } from "@api/@types/charge";
